import React from "react";
import {
  baseClasses,
  variantClasses,
  sizeClasses,
  BadgeVariant,
  roundedClasses,
} from "./constants";

export interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  size?: "sm" | "md" | "lg";
  rounded?: "full" | "sm" | "md" | "lg";
  indicator?: string | number;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({
  children,
  variant = "default",
  size = "md",
  indicator,
  rounded,
  className = "",
}) => {
  const classes = [
    baseClasses,
    rounded ? roundedClasses[rounded] : "",
    variantClasses[variant],
    sizeClasses[size],
    className,
  ].join(" ");

  return (
    <span className={classes}>
      {children}
      {indicator !== undefined && (
        <span className="ml-1.5 py-0.5 px-1.5 rounded-full text-xs bg-white bg-opacity-25">
          {indicator}
        </span>
      )}
    </span>
  );
};

export default Badge;
